import { Rating } from "react-simple-star-rating";
import Form from "react-bootstrap/Form";
import { Fragment, useState } from "react";

export default function RatingFilter(props) {
  //  check box for 1-5 stars ratings (react simple star rating npm package)
  // allows the user to filter products based on ratings

  const [ratingCollapsed, setRatingCollapsed] = useState(false);

  const filterHeader = (
    <Form.Label
      className="fw-bold"
      style={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      Rating
      <div>
        {props?.selectedRatings?.includes(true) > 0 && (
          <i
            className="bi bi-arrow-counterclockwise me-3 pointer"
            onClick={() => {
              props.handleChangeRating(0, 0);
            }}
          ></i>
        )}
        {ratingCollapsed ? (
          <i
            onClick={() => setRatingCollapsed(false)}
            className="bi bi-plus pointer"
          ></i>
        ) : (
          <i
            onClick={() => setRatingCollapsed(true)}
            className="bi bi-dash pointer"
          ></i>
        )}
      </div>
    </Form.Label>
  );
  return (
    <>
      {filterHeader}
      {/* stars */}
      <div className={ratingCollapsed ? "hide-element" : ""}>
        {Array.from({ length: 5 }).map((_, idx) => {
          return (
            <Fragment key={idx}>
              <Form.Check type="checkbox" id={`check-api-${idx}`}>
                <Form.Check.Input
                  type="checkbox"
                  isValid
                  checked={props?.selectedRatings[4 - idx] || false}
                  onChange={(event) => {
                    const isChecked = event.target.checked;
                    //have array [false,true,false,...] where idx 0 = 1 star etc
                    props.handleChangeRating(5 - idx, isChecked);
                  }}
                />
                <Form.Check.Label style={{ cursor: "pointer" }}>
                  <Rating readonly size={20} initialValue={5 - idx} />
                </Form.Check.Label>
              </Form.Check>
            </Fragment>
          );
        })}
      </div>
    </>
  );
}
